/**
 * Shared @dnd-kit configuration constants
 * Used by KanbanBoard and RequirementsList
 */

import { defaultDropAnimationSideEffects } from '@dnd-kit/core';
import type { DropAnimation } from '@dnd-kit/core';

/** Minimum drag distance before activation — prevents accidental drags on click (pixels) */
export const DND_POINTER_ACTIVATION = { distance: 5 } as const;

/** Standard drop animation with reduced opacity on the active (source) element */
export const DND_DROP_ANIMATION: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: { active: { opacity: '0.4' } },
  }),
};
